const blank = 'assets/svgs/img-placeholder-TYPE.svg'

export const transparent = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'

export const placeholder = (type: string): string => type ? blank.replace('TYPE', type) : transparent
